module.exports = __webpack_public_path__ + "img/kangaroo.4c51a12f.png";